<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89542 18 6 18H14C15.1046 18 16 17.1046 16 16V4C16 2.89542 15.1046 2 14 2H6ZM2 4C2 1.79087 3.79087 0 6 0H14C16.2092 0 18 1.79088 18 4V16C18 18.2092 16.2092 20 14 20H6C3.79088 20 2 18.2092 2 16V4ZM7 10C7 9.44771 7.44772 9 8 9H12C12.5523 9 13 9.44771 13 10C13 10.5523 12.5523 11 12 11H8C7.44772 11 7 10.5523 7 10ZM7 14C7 13.4477 7.44772 13 8 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H8C7.44772 15 7 14.5523 7 14Z" fill="#858E97"/>
    </svg>
</template>

<script>
export default {
    name: 'IconList',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
